import { render, staticRenderFns } from "./NewChurch.vue?vue&type=template&id=78c16020&scoped=true&"
import script from "./NewChurch.vue?vue&type=script&lang=js&"
export * from "./NewChurch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c16020",
  null
  
)

export default component.exports